export enum ProductAvailabilityStatus {
  IN_STOCK = 'in-stock',
  NON_STOCKABLE = 'non-stockable',
  OUT_OF_STOCK = 'out-of-stock',
  OUT_OF_STOCK_REPLENISHABLE = 'out-of-stock-replenishable',
}
